import { Link } from "react-router-dom";
import { ArrowRight, Check, FileSearch } from "lucide-react";
import { Crumbs } from "../product/ProductHero";
import { MediaImage } from "../MediaImage";
import { useSiteMedia } from "../../lib/siteMedia";
import { trackEvent } from "../../lib/api";
import { QuoteButton } from "../home/CtaButtons";

export const CompareLink = ({ location, dark = false, className = "", label = "Heeft u al een offerte? Laat deze vergelijken." }) => (
  <Link to="/offerte-vergelijken" onClick={() => trackEvent("cta_compare_click", { location })} data-testid={`${location}-compare-cta`}
    className={`group inline-flex items-center gap-2 text-[15px] font-semibold underline decoration-2 underline-offset-[6px] transition-colors ${dark ? "text-white decoration-white/30 hover:decoration-white" : "text-ink decoration-maas/30 hover:text-maas hover:decoration-maas"} ${className}`}>
    <FileSearch className={`h-4 w-4 shrink-0 ${dark ? "text-[#7FD3D6]" : "text-maas"}`} aria-hidden="true" /> {label}
    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
  </Link>
);

// Lichte hero voor informatiepagina's (zelfde opbouw als de V3-productpagina's).
export const InfoHero = ({ crumbs, eyebrow, block, points = [], mediaKey, location, onderwerp, badge }) => {
  const media = useSiteMedia();
  return (
    <section aria-labelledby="info-title" className="relative overflow-hidden bg-white" data-testid="info-hero">
      <div className="hero-grid absolute inset-y-0 right-0 hidden w-[50%] lg:block" aria-hidden="true" />
      <div className="container-tight relative grid items-center gap-10 pb-12 pt-6 sm:pt-8 lg:grid-cols-12 lg:gap-12 lg:pb-16">
        <div className="reveal-hero lg:col-span-6">
          <Crumbs items={crumbs} />
          <p className="eyebrow mt-6">{eyebrow}</p>
          <h1 id="info-title" className="h1 mt-3 text-balance lg:text-[2.6rem] xl:text-[3rem]" data-testid="info-title">{block.title}</h1>
          <p className="lead mt-4 max-w-xl" data-testid="info-lead">{block.body}</p>
          {points.length > 0 && (
            <ul className="mt-5 grid gap-2 text-[15px] text-ink">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-2.5"><span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-maas-soft"><Check className="h-3.5 w-3.5 text-maas" aria-hidden="true" /></span>{p}</li>
              ))}
            </ul>
          )}
          <div className="mt-7 flex flex-col gap-4 sm:items-start">
            <QuoteButton location={location} onderwerp={onderwerp} />
            <CompareLink location={location} />
          </div>
        </div>
        <div className="reveal-hero relative lg:col-span-6 [animation-delay:120ms]">
          <div className="frame">
            <MediaImage media={media(mediaKey)} priority sizes="(min-width: 1024px) 620px, calc(100vw - 32px)" className="aspect-[4/3] rounded-[14px] sm:aspect-[3/2]" testId="info-hero-image" />
          </div>
          {badge && (
            <div className="card absolute -bottom-6 left-4 flex max-w-[300px] items-center gap-3 p-4 pr-5 sm:left-8" style={{ boxShadow: "var(--shadow-2)" }}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maas-soft text-maas"><badge.icon className="h-5 w-5" aria-hidden="true" /></span>
              <div><p className="text-[15px] font-semibold text-ink">{badge.title}</p><p className="text-[13px] text-slate-500">{badge.text}</p></div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
